import React, { useEffect, useState } from 'react';
import { Typography, Avatar, message, Image, Button } from 'antd';
import {
  ExclamationCircleOutlined,
  AlertFilled,
  UserOutlined,
  LogoutOutlined,
  CustomerServiceFilled,
  CheckOutlined,
  DollarCircleOutlined,
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import * as actions from '../../redux/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import connectCSKH from '../../utils/connectCSKH';
import tickAsset from '../../assets/tick.png';
import './User.scss';
import api from '../../api';
import ModalHopDong from '../../components/ModalHopDong';

export default function User() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state._auth);
  const { cskh } = useSelector((state) => state._content);
  const [visible, setVisible] = useState(false);
  const [contract, setContract] = useState(null);

  const loadProfile = async () => {
    const { data } = await api.get('/users/profile');
    dispatch(actions.initialLogin(data.data));
  }

  const getContract = async () => {
    const { data } = await api.get('/contracts');
    if (data.data.length > 0) setContract(data.data[0]);
  }

  useEffect(() => {
    loadProfile()
    getContract()
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0.3, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="header">
        <Typography.Text className="header-text">파일</Typography.Text>
      </div>
      <div className="avatar">
        <Avatar
          size={120}
          src={profile?.kyc?.id_with_face || profile?.avatar}
        />
        <Typography.Text strong style={{ fontSize: 23, color: '#121212' }}>
          {profile?.kyc?.name}
        </Typography.Text>
        <Typography.Text
          style={{ fontSize: 18, color: '#666', fontWeight: 500 }}
        >
          {profile?.phone}
        </Typography.Text>
      </div>
      {!profile?.kyc?.name && <AlertVerify />}
      <div style={{ padding: 20 }}>
        <Tab
          title="대출계약"
          icon={
            <DollarCircleOutlined
              style={{ color: '#fff', fontSize: 25, marginRight: 20 }}
            />
          }
          onClick={
            profile?.kyc?.name
              ? () => setVisible(true)
              : () => message.info('본인 인증을 하지 않으셨습니다.')
          }
        />
        <ModalHopDong visible={visible}
                      setVisible={setVisible}
                      data={contract}
                      profile={profile}/>
        <Tab
          title="개인정보"
          icon={
            <UserOutlined
              style={{ color: '#fff', fontSize: 25, marginRight: 20 }}
            />
          }
          onClick={
            profile?.kyc?.name
              ? () => history.push('/detail-profile')
              : () => message.info('본인 인증을 하지 않으셨습니다.')
          }
        />
        <Tab
          title="조언을 위한 연락처 - 지원"
          icon={
            <CustomerServiceFilled
              style={{ color: '#fff', fontSize: 25, marginRight: 20 }}
            />
          }
          // onClick={() => window.open('#')} // link CSKH
          onClick={() => connectCSKH(profile)}
        />
        <motion.div
          whileTap={{ scale: 0.95, opacity: 0.4 }}
          className="log-out"
        >
          <Button
            className="log-out-btn"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            icon={<LogoutOutlined style={{ fontSize: 25, color: '#fff' }} />}
            onClick={() => dispatch(actions.Logout())}
          >
            로그아웃
          </Button>
        </motion.div>
      </div>
      <div
        style={{
          paddingTop: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        {/* <Image src={tickAsset} preview={false} style={{ maxWidth: 100 }} /> */}
        <Typography.Text
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#555',
            textAlign: 'center',
          }}
        >
          &reg; 저작권은 KEB Hana Bank에 속합니다
        </Typography.Text>
      </div>
    </motion.div>
  );
}

const Tab = ({ title, onClick, icon }) => {
  return (
    <motion.div
      whileTap={{
        scale: 0.96,
        opacity: 0.3,
        border: '1px solid rgba(0, 106, 176,0.3)',
      }}
      onClick={onClick}
      className="tab"
    >
      {icon}
      <Typography.Text className="tab-text" style={{ color: '#fff' }}>
        {title}
      </Typography.Text>
    </motion.div>
  );
};
const AlertVerify = ({ status }) => {
  const history = useHistory();

  return (
    <div className="alert-container">
      <div>
        <Typography.Text strong style={{ fontSize: 17, color: '#121212' }}>
          계정 확인
        </Typography.Text>
        <div
          style={{
            borderBottom: '1px solid rgba(0, 106, 176,0.3)',
            height: 0.1,
            width: '100%',
          }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '30px 10px',
          }}
        >
          <div
            style={{
              flex: 1,
              minWidth: '30%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <AlertFilled style={{ fontSize: 45, color: '#242ba6' }} />
          </div>
          <div>
            <Typography.Text
              style={{ fontSize: 16, fontWeight: 400, color: '#121212' }}
            >
              주민등록증과 인물 사진을 추가하여 본인 인증을 완료하세요
            </Typography.Text>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '0px 10px',
          }}
        >
          <motion.div
            whileTap={{ scale: 0.9, opacity: 0.3 }}
            onClick={() => history.push('/verify')}
          >
            <Typography.Text
              strong
              style={{
                textAlign: 'right',
                fontWeight: '700',
                color: '#0022ba',
                fontSize: 17,
              }}
            >
              지금 확인
            </Typography.Text>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
const IsVerify = ({ status }) => {
  return (
    <div
      className="verify"
      style={{
        background: status ? '#28ba00' : 'rgba(0,0,0,0.1)',
      }}
    >
      {status ? (
        <>
          <CheckOutlined
            style={{
              color: '#87d489',
              fontSize: 20,
            }}
          />
          <Typography.Text
            style={{
              flex: 1,
              textAlign: 'center',
              color: '#fff',
              fontWeight: 500,
            }}
          >
            확인됨
          </Typography.Text>
        </>
      ) : (
        <>
          <ExclamationCircleOutlined
            style={{
              color: '#666',
              fontSize: 20,
            }}
          />
          <Typography.Text style={{ flex: 1, textAlign: 'center' }}>
            확인되지 않음
          </Typography.Text>
        </>
      )}
    </div>
  );
};
